<li class="ant-timeline-item" #liTemplate>
  <div class="ant-timeline-item-tail"></div>
  <div
    class="ant-timeline-item-head"
    [class.ant-timeline-item-head-custom]="dwDot"
    [ngClass]="classMap">
    <ng-container *ngIf="isDotString; else dotTemplate">{{ dwDot }}</ng-container>
    <ng-template #dotTemplate>
      <ng-template [ngTemplateOutlet]="dwDot"></ng-template>
    </ng-template>
  </div>
  <div class="ant-timeline-item-content">
    <ng-content></ng-content>
  </div>
</li>